// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_o2-0";
export var discountCodeInput = "_o2-1";